export default __webpack_public_path__ + "static/media/tr.3a7c1ff2.svg";